
<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
    (onboardingIcon)="startTour()"  
      (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"
    ></app-header>
  
    <div class="sggs-dashboard-content">
      <div class="carousel-wrapper">
        <ng-container *ngIf="isDynamicSlidesLoading">
          <div class="carousel-loader-wrapper animate"></div>
        </ng-container>

        <ng-container *ngIf="!isDynamicSlidesLoading">
          <owl-carousel-o
          class="cursor-pointer"
            [options]="customOptions"
            (translated)="getPassedData($event)"
            (initialized)="getData($event)"
            #mainCarousel
          >
            <ng-container *ngIf="dynamicSlides.length">
              <ng-container *ngFor="let slide of dynamicSlides">
                <ng-template  carouselSlide [id]="slide.SikhriEventID">
                  
                  <div
                    *ngIf="!isHandsetPortrait"
                    style="background-image: url('{{ slide.ImageURL }}'); "
                    (click)="carouselClick(slide)"
                    class="carousel-text-wrapper carousel-text-wrapper-home desktop"
                  >
                  <!-- <div
                    *ngIf="!isHandsetPortrait"
                    [attr.data-bg-url]="slide.ImageURL"
                    (click)="carouselClick(slide)"
                    class="carousel-text-wrapper carousel-text-wrapper-home desktop"
                    style="background-image: none;"> -->


                    <div class="carousel-heading">{{ slide.Heading }}</div>
                    <div class="carousel-sub-heading">
                      {{ slide.SubHeading }}
                    </div>
                  </div>

                  <div
                    *ngIf="isHandsetPortrait"
                    (click)="carouselClick(slide)"
                    style="background-image: url('{{ slide.MobileImageURL }}'); "
                    class="carousel-text-wrapper carousel-text-wrapper-home small-device"
                  >
                    <div class="carousel-heading">{{ slide.Heading }}</div>
                    <div class="carousel-sub-heading">
                      {{ slide.SubHeading }}
                    </div> 
                  </div>


                </ng-template>
              </ng-container>
            </ng-container>
          </owl-carousel-o>
          <div class="main-carousel-nav">
            <div class="carousel-nav-control" (click)="mainCarousel.prev()">
              <span> &#8249; </span>
            </div>
            <div class="carousel-nav-control" (click)="mainCarousel.next()">
              &#8250;
            </div>
          </div>
        </ng-container>
      </div>

      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <!--featured posts start-->
        <div class="featured-wrapper mt-4">
          <div class="featured-heading" [class.is-mobile]="isHandsetPortrait">
            <h1 id="recent" class="main-heading-left">{{ "Featured" | translate }} {{ "Bani - Guru Granth Sahib" | translate }}</h1>
          </div>
          <div class="featured-posts" [class.is-mobile]="isHandsetPortrait">
            <div
              *ngIf="isHandsetPortrait"
              class="dashboard-posts-carousel-wrapper"
            >
              <owl-carousel-o
                [options]="customOptions"
                (translated)="getPassedData($event)"
                (initialized)="getData($event)"
                #featuredCarousel
              >
                <ng-container
                  *ngIf="isFeaturedLoading && !dynamicFeaturedSlides.length"
                >
                  <ng-container *ngFor="let slide of [0,1,2]">
                    <ng-template carouselSlide >
                      <div class="featured-post-wrapper 1">
                        <div class="featured-video-wrapper 2">
                          <div class="featured-video-thumbnail animate 3"></div>
                        </div>
                        <div class="featured-video-description">
                          <div class="featured-video-heading">
                            <div class="loading-heading animate"></div>
                          </div>
                          <div class="featured-video-sub-heading">
                            <div class="loading-line animate"></div>
                            <div class="loading-line animate"></div>
                            <div class="loading-line animate"></div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </ng-container>
                </ng-container>

                <ng-container
                  *ngIf="!isFeaturedLoading && dynamicFeaturedSlides.length"
                >
                  <ng-container
                    *ngFor="let featuredPost of dynamicFeaturedSlides"
                  >
                    <ng-template carouselSlide [id]="featuredPost.BaniId">
                      <div
                        style="
                          background-image: url('{{ fetchImageThumbnail(featuredPost) }}');
                        "
                        class="carousel-text-wrapper is-mobile"
                        (click)="openVideoPopup(featuredPost)"
                      >
                        <div *ngIf="featuredPost.BaniVideoURL" class="video-thumbnail-cover">
                          <img alt="Play Button Image" src="/assets/images/play.webp" />
                        </div>
                      </div>
                      <div class="mobile-carousel-text-wrapper">
                        <div class="carousel-heading">
                          {{ featuredPost.BaniName }}
                        </div>
                        <div class="carousel-sub-heading">
                          {{
                            featuredPost?.Introduction?.trim()
                              ? showSmallerString(featuredPost.Introduction)
                              : "Coming_Soon" | translate 
                          }}
                          <span
                            (click)="goToPost(featuredPost.BaniCode)"
                            class="view-more-link"
                          >
                            {{ "more" | translate }}...
                          </span>
                        </div>
                      </div>
                    </ng-template>
                  </ng-container>
                </ng-container>

              </owl-carousel-o>
              <div class="featured-carousel-nav">
                <div
                  class="carousel-nav-control"
                  (click)="featuredCarousel.prev()"
                >
                  <span> &#8249; </span>
                </div>
                <div
                  class="carousel-nav-control"
                  (click)="featuredCarousel.next()"
                >
                  &#8250;
                </div>
              </div>
            </div>
            <mat-grid-list
              *ngIf="!isHandsetPortrait"
              cols="3"
              rowHeight="410px"
              gutterSize="5px"
            >
              <ng-container *ngIf="isFeaturedLoading">
                <mat-grid-tile *ngFor="let loading of [0, 1, 2]"
                  ><div class="featured-post-wrapper">
                    <div class="featured-video-wrapper">
                      <div class="featured-video-thumbnail animate"></div>
                    </div>
                    <div class="featured-video-description">
                      <div class="featured-video-heading">
                        <div class="loading-heading animate"></div>
                      </div>
                      <div class="featured-video-sub-heading">
                        <div class="loading-line animate"></div>
                        <div class="loading-line animate"></div>
                        <div class="loading-line animate"></div>
                      </div>
                    </div></div
                ></mat-grid-tile>
              </ng-container>
              
              <ng-container *ngIf="!isFeaturedLoading">
                <mat-grid-tile
                  *ngFor="let featuredPost of dynamicFeaturedSlides"
                  ><div class="featured-post-wrapper">
                    <div class="featured-video-wrapper">
                      <div 
                      class="featured-video-thumbnail youtub-thumb 1" 
                      style="background-image: url('{{ fetchImageThumbnail(featuredPost) }}');" 
                      (click)="openVideoPopup(featuredPost)"
                      >
                        <div *ngIf="featuredPost.BaniVideoURL" class="video-thumbnail-cover">
                          <img alt="Play Button Image" src="/assets/images/play.webp" />
                        </div>
                      </div>
                    </div>
                    <a class="view-more-div" href="/bani/{{featuredPost.BaniCode}}">
                    <div (click)="goToPost(featuredPost.BaniCode)" class="featured-video-description">
                      <div class="featured-video-heading">
                        {{ featuredPost.BaniName }}
                      </div>
                      <div class="featured-video-sub-heading">
                        {{
                          featuredPost?.Introduction?.trim()
                            ? showSmallerString(featuredPost.Introduction)
                            : ""
                        }}
                        <span
                          class="view-more-link"
                        >
                        {{ "more" | translate }}...
                        </span>
                      </div>
                    </div>
                    </a>
                  </div></mat-grid-tile
                >
              </ng-container>
            </mat-grid-list>
          </div>
        </div>
        <!--featured posts stop-->

        <!--recent releases start-->
        <div class="featured-wrapper">
          <div class="featured-heading" [class.is-mobile]="isHandsetPortrait">
            <!-- <div id="recent1" class="main-heading-left">{{ "Recent Releases" | translate }}</div> -->
            <h2 id="recent1" class="main-heading-left">{{ "Recent Releases" | translate }}</h2>
          </div>
          <div class="featured-posts" [class.is-mobile]="isHandsetPortrait">
            <div
              *ngIf="isHandsetPortrait"
              class="dashboard-posts-carousel-wrapper"
            >
              <owl-carousel-o
                [options]="customOptions"
                (translated)="getPassedData($event)"
                (initialized)="getData($event)"
                #recentCarousel
              >
                <ng-container *ngIf="recentReleases.length">
                  <ng-container *ngFor="let recentPost of recentReleases">
                    <ng-template
                      carouselSlide
                      [id]="parseAsString(recentPost.BaniId)"
                    >
                      <div
                        (click)="goToPost(recentPost.BaniCode)"
                        style="
                          background-image: url('{{ fetchImageThumbnail(recentPost) }}');
                        "
                        class="carousel-text-wrapper is-mobile"
                      ></div>
                      <div
                        (click)="goToPost(recentPost.BaniCode)"
                        class="mobile-carousel-text-wrapper"
                      >
                        <div class="carousel-heading">
                          {{
                            recentPost?.BaniName?.trim()
                              ? recentPost.BaniName
                              : "In Progress"
                          }}
                        </div>
                        <div class="carousel-sub-heading">
                          {{
                            recentPost?.Introduction?.trim()
                              ? showSmallerRecentString(recentPost.Introduction)
                              : "Coming_Soon" | translate 
                          }}
                          <span 
                            class="view-more-link"
                          >
                            <a class="view-more-link" href="/bani/{{recentPost.BaniCode}}">{{ "more" | translate }}...</a>
                          </span>
                        </div>
                      </div>
                    </ng-template>
                  </ng-container>
                </ng-container>
              </owl-carousel-o>
              <div class="featured-carousel-nav">
                <div
                  class="carousel-nav-control"
                  (click)="recentCarousel.prev()"
                >
                  <span> &#8249; </span>
                </div>
                <div
                  class="carousel-nav-control"
                  (click)="recentCarousel.next()"
                >
                  &#8250;
                </div>
              </div>
            </div>

            <ng-container *ngIf="isRecentPostsLoading">
              <mat-grid-list
                *ngIf="!isHandsetPortrait"
                cols="3"
                rowHeight="390px"
                gutterSize="5px"
              >
                <mat-grid-tile *ngFor="let loading of [0, 1, 2]"
                  ><div class="featured-post-wrapper">
                    <div class="featured-video-wrapper">
                      <div class="featured-video-thumbnail animate"></div>
                    </div>
                    <div class="featured-video-description">
                      <div class="featured-video-heading">
                        <div class="loading-heading animate"></div>
                      </div>
                      <div class="featured-video-sub-heading">
                        <div class="loading-line animate"></div>
                        <div class="loading-line animate"></div>
                        <div class="loading-line animate"></div>
                      </div>
                    </div></div
                ></mat-grid-tile>
              </mat-grid-list>
            </ng-container>
            <ng-container *ngIf="!isRecentPostsLoading">
              <mat-grid-list
                *ngIf="!isHandsetPortrait"
                cols="3"
                rowHeight="410px"
                gutterSize="5px"
              >
                <mat-grid-tile *ngFor="let recentPost of recentReleases"
                  ><div class="featured-post-wrapper">
                    <div class="featured-video-wrapper">
                      <div 
                      class="featured-video-thumbnail youtub-thumb" 
                      style="background-image: url('{{ fetchImageThumbnail(recentPost) }}');" 
                      (click)="openVideoPopup(recentPost)"
                      >
                        <div *ngIf="recentPost.BaniVideoURL" class="video-thumbnail-cover">
                          <img alt="Play Button Image" src="/assets/images/play.webp" />
                        </div>
                      </div>
                    </div>
                    <a class="view-more-div" href="/bani/{{recentPost.BaniCode}}">
                    <div (click)="goToPost(recentPost.BaniCode)" class="featured-video-description">
                      <div class="featured-video-heading">
                        {{ recentPost.BaniName }}
                      </div>
                      <div class="featured-video-sub-heading">
                        {{
                          recentPost?.Introduction?.trim()
                            ? showSmallerRecentString(recentPost.Introduction)
                            : "Coming_Soon" | translate 
                        }}
                        <span
                          
                          class="view-more-link"
                        >
                          {{ "more" | translate }}...
                        </span>
                      </div>
                    </div>
                    </a>
                  </div></mat-grid-tile
                >
              </mat-grid-list>
            </ng-container>
          </div>
          <div class="mt-4" style="text-align: right;">
            <button
              class="sggs-primary-button"
              mat-stroked-button
              color="primary"
              *ngIf="!isHandsetPortrait"
              (click)="goToSearch()"
            >
              {{ "View More" | translate }}
            </button>
          </div>
        </div>
        <!--recent releases stop-->

        <!-- upcoming releases start-->
         <!--  Removing this section by styling display none -->
        <div class="featured-wrapper" style="display: none;">
          <div class="featured-heading" [class.is-mobile]="isHandsetPortrait">
            <div class="main-heading-left">{{ "Upcoming Releases" | translate }}</div>
          </div>
          <div class="featured-posts" [class.is-mobile]="isHandsetPortrait">
            <div
              *ngIf="isHandsetPortrait"
              class="dashboard-posts-carousel-wrapper"
            >
              <owl-carousel-o
                [options]="customOptions"
                (translated)="getPassedData($event)"
                (initialized)="getData($event)"
                #upcomingCarousel
              >
                <ng-container
                  *ngIf="isUpcomingPostsLoading"
                >
                  <ng-container *ngFor="let slide of [0,1,2]">
                    <ng-template carouselSlide>
                      <div class="featured-post-wrapper">
                        <div class="featured-video-wrapper">
                          <div class="featured-video-thumbnail animate"></div>
                        </div>
                        <div class="featured-video-description">
                          <div class="featured-video-heading">
                            <div class="loading-heading animate"></div>
                          </div>
                          <div class="featured-video-sub-heading">
                            <div class="loading-line animate"></div>
                            <div class="loading-line animate"></div>
                            <div class="loading-line animate"></div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </ng-container>
                </ng-container>

                <ng-container
                  *ngIf="
                    !isUpcomingPostsLoading 
                  "
                >
                  <ng-container *ngFor="let featuredPost of dynamicUpcomingSlides">
                    
                    <ng-template carouselSlide [id]="featuredPost.BaniId">
                      <div
                        style="
                          background-image: url('{{ fetchImageThumbnail(featuredPost) }}');
                        "
                        class="carousel-text-wrapper is-mobile"
                        (click)="openVideoPopup(featuredPost)"
                      >
                        <div *ngIf="featuredPost.BaniVideoURL" class="video-thumbnail-cover">
                          <img alt="Play Button Image" src="/assets/images/play.webp" />
                        </div>
                      </div>
                      <div (click)="goToPost(featuredPost.BaniCode)" class="mobile-carousel-text-wrapper">
                        <div class="carousel-heading">
                          {{ featuredPost.BaniName }}
                        </div>
                        <div class="carousel-sub-heading">
                          {{
                            featuredPost?.Introduction?.trim()
                              ? showSmallerString(featuredPost.Introduction)
                              : "Coming_Soon" | translate 
                          }}
                          <span
                            
                            class="view-more-link"
                          >
                            <a class="view-more-link" href="/bani/{{featuredPost.BaniCode}}">{{ "more" | translate }}...</a>
                          </span>
                        </div>
                      </div>
                    </ng-template>
                  </ng-container>
                </ng-container>
              </owl-carousel-o>
              <div class="featured-carousel-nav">
                <div
                  class="carousel-nav-control"
                  (click)="upcomingCarousel.prev()"
                >
                  <span> &#8249; </span>
                </div>
                <div
                  class="carousel-nav-control"
                  (click)="upcomingCarousel.next()"
                >
                  &#8250;
                </div>
              </div>
            </div>
            <ng-container *ngIf="isUpcomingPostsLoading">
              <mat-grid-list
                *ngIf="!isHandsetPortrait"
                cols="3"
                rowHeight="390px"
                gutterSize="5px"
              >
                <mat-grid-tile *ngFor="let loading of [0, 1, 2]"
                  ><div class="featured-post-wrapper">
                    <div class="featured-video-wrapper">
                      <div class="featured-video-thumbnail animate"></div>
                    </div>
                    <div class="featured-video-description">
                      <div class="featured-video-heading">
                        <div class="loading-heading animate"></div>
                      </div>
                      <div class="featured-video-sub-heading">
                        <div class="loading-line animate"></div>
                        <div class="loading-line animate"></div>
                        <div class="loading-line animate"></div>
                      </div>
                    </div></div
                ></mat-grid-tile>
              </mat-grid-list>
            </ng-container>
            <ng-container *ngIf="!isUpcomingPostsLoading">
              <mat-grid-list
                *ngIf="!isHandsetPortrait"
                cols="3"
                rowHeight="390px"
                gutterSize="5px"
              >
              <mat-grid-tile
                  *ngFor="let featuredPost of dynamicUpcomingSlides"
                  ><div class="featured-post-wrapper">
                    <div class="featured-video-wrapper">
                      <div 
                      class="featured-video-thumbnail youtub-thumb" 
                      style="background-image: url('{{ fetchImageThumbnail(featuredPost) }}');" 
                      (click)="openVideoPopup(featuredPost)"
                      >
                        <div *ngIf="featuredPost.BaniVideoURL" class="video-thumbnail-cover">
                          <img alt="Play Button Image" src="/assets/images/play.webp" />
                        </div>
                      </div>
                    </div>
                    <div class="featured-video-description">
                      <div class="featured-video-heading">
                        {{ featuredPost.BaniName }}
                      </div>
                      <div class="featured-video-sub-heading vj">
                        {{
                          featuredPost?.Introduction?.trim()
                            ? showSmallerString(featuredPost.Introduction)
                            : "Coming_Soon" | translate 
                        }}
                        <span
                          
                          class="view-more-link"
                        >
                           <a class="view-more-link" href="/bani/{{featuredPost.BaniCode}}">{{ "more" | translate }}...</a>
                        </span>
                      </div>
                    </div>
                  </div></mat-grid-tile
                >               
                
              </mat-grid-list>
            </ng-container>
          </div>
        </div>
        <!-- upcoming releases stop-->

        <!-- Significant Terms start -->
        <div class="featured-wrapper">
          <div class="featured-heading significant-terms-heading">
           <!--  <div class="main-heading-left">{{ "glossary" | translate }}</div> -->
           <h3 class="main-heading-left">{{ "glossary" | translate }}</h3>
          </div>
          <div class="featured-posts" [class.is-mobile]="isHandsetPortrait">
            <ng-container *ngIf="isSignificantTermsLoading">
              <mat-grid-list
                cols="{{ isHandsetPortrait ? 1 : 3 }}"
                rowHeight="125px"
                gutterSize="5px"
              >
                <mat-grid-tile
                  *ngFor="let term of [0, 1, 2, 3, 4, 5]"
                  class="significant-term-tile"
                >
                  <div
                    class="significant-term-wrapper"
                    [class.is-mobile]="isHandsetPortrait"
                  >
                    <div class="significant-term-heading">
                      <div class="loading-heading animate"></div>
                    </div>
                    <div class="significant-term-content">
                      <div class="loading-line animate"></div>
                      <div class="loading-line animate"></div>
                    </div>
                  </div>
                </mat-grid-tile>
              </mat-grid-list>
            </ng-container>
            <ng-container *ngIf="!isSignificantTermsLoading">
              <mat-grid-list
                cols="{{ isHandsetPortrait ? 1 : 3 }}"
                gutterSize="8px"
                rowHeight="170px">
                <mat-grid-tile
                  *ngFor="let term of significantTerms"
                  class="significant-term-tile"
                >
                  <div
                    class="significant-term-wrapper"
                    [class.is-mobile]="isHandsetPortrait"
                  >
                    <div class="significant-term-heading">
                      {{ term.WordName }}
                    </div>
                    <div class="significant-term-content">
                      {{
                        term?.WordDescription?.trim()
                          ? showSmallerString(term.WordDescription)
                          :  "Coming_Soon" | translate 
                      }}
                      <span
                        (click)="goToSignificantTermDetail(term.WordName)"
                        class="view-more-link"
                      >
                         <a class="view-more-link" href="/significant-term-detail/{{term.WordName}}">{{ "more" | translate }}...</a>
                      </span>
                    </div>
                  </div>
                </mat-grid-tile>
              </mat-grid-list>
            </ng-container>
            <div style="text-align: right;margin-top: 10px;">
              <button
                class="sggs-primary-button"
                mat-stroked-button
                color="primary"
                (click)="goToSignificantTerms()"
                *ngIf="!isHandsetPortrait"
              >
                {{ "View More" | translate }}
              </button>
            </div>

            <div
              *ngIf="isHandsetPortrait"
              class="terms-view-more-button-wrapper"
            >
              <button
                (click)="goToSignificantTerms()"
                class="black-button"
                mat-stroked-button
                color="primary"
              >
                {{ "View More" | translate }}
              </button>
            </div>
          </div>
        </div>

        <!-- Significant Terms stop -->

       
      </div>
       <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<ngx-guided-tour
    skipText="SKIP"
    nextText="NEXT"
    backText="BACK"
    doneText="Complete"
  ></ngx-guided-tour>
  
  <ng-template #template let-currentStepNumber="num" let-totalSteps="total"
    >I'm in </ng-template
  >
